export enum ControlType {
    Text = 0,
    //DateTime=1,
    Help = 1,
    DropDown = 2,
    DateRange = 3,
    NumberRange = 4,
    Search = 5,
    Date = 6,
    CheckboxGroup = 7,
    DateRangeTime = 8,
    Radio = 9,
    Year = 10,
    Month = 11,
    MonthRange = 12,
    YearRange = 13,
    InputGroup = 14,
    ComboLookUp = 15
}
